import menu from './menu';
import notifications from './notifications';

export default {
    rootPath: window.env.APP_URL,
    cmsPath: '/admin',
    cmsTitle: window.env.APP_NAME,
    routes: {
        default: '/dashboard',
        endpoints: {
            '^/pages$': {
                params: { filter: 'parent_id:$null' },

            },
            '^/panels$': {
                params: { filter: 'content_id:$null' },
            },
            '^/categories$': {
                params: { filter: 'parent_id:$null' },
            },
            '^/customers$': {
                params: { sort: 'name:asc', include: 'sub_customers', filter: 'parent_id:$null' }
            },
            '^/customer_logins$': {
                params: { sort: 'registered_at:desc' }
            },
            '^/enquiries$': {
                params: { sort: 'enquiry_date:desc' }
            },
            '^/orders$': {
                params: { sort: 'order_date:desc' }
            },
            '^/order/[\\d]+$': {
                params: { include: 'items,customer,customer_login' }
            },
            '^/order/[\\d]+/status$': {
                params: { sort: 'created_at:desc' }
            },
            '^/order/[\\d]+/payment_log$': {
                params: { sort: 'created_at:desc' }
            },
            '^/invoice/[\\w]+$': {
                params: { include: 'lines,customer' }
            },
            '^/category_groups$': {
                params: { sort: 'name:asc' }
            },
            '^/product_groups$': {
                params: { sort: 'parent_id:asc;name:asc', filter: 'parent_id:$null' }
            },
            '^/products$': {
                params: { append: 'category_list' }
            },
            '^/customer_login/[\\d]+/login_log$': {
                params: { sort: 'created_at:desc' }
            },
            '^/report_logins': {
                params: { sort: 'account_number:asc' }
            },
            '^/customer_queries': {
                params: { sort: 'created_at:desc' }
            },
        }
    },
    file: {
        extensions: {
            img: ['png', 'jpg', 'jpeg', 'gif', 'svg', 'tiff'],
            doc: ['doc', 'docx'],
            pdf: ['pdf'],
            xls: ['xls', 'xlsx'],
            csv: ['csv'],
        }
    },
    menu,
    notifications,
}



// WEBPACK FOOTER //
// ./resources/assets/cms/js/config/base.js